module.exports = __webpack_public_path__ + "static/media/microphone-alt-slash.705ea086.svg";